import React, { useContext } from 'react';

import { Result, Alert } from 'antd';
import { Center, Loader } from '@mantine/core';
import PropTypes from 'prop-types';

// eslint-disable-next-line no-use-before-define
MenuInformation.Context = React.createContext();

// eslint-disable-next-line no-use-before-define
MenuInformation.MenuStatus = function MenuStatus() {
  // eslint-disable-next-line no-use-before-define
  const { cubohMenus } = useContext(MenuInformation.Context);

  if (cubohMenus?.isLoading) {
    return (
      <Center style={{ flexGrow: 1 }}>
        <Loader />
      </Center>
    );
  }
  if (cubohMenus?.error?.hasError) {
    return (
      <Result
        status="500"
        title="Unable to load Menus."
        subTitle="Sorry, something went wrong. Please contact support for assistance."
        extra={<Alert message={`Error: ${cubohMenus?.error?.message}`} type="error" />}
      />
    );
  }
};

function MenuInformation({ children, ...rest }) {
  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <MenuInformation.Context.Provider value={{ ...rest }}>
      {children}
    </MenuInformation.Context.Provider>
  );
}
MenuInformation.propTypes = {
  children: PropTypes.node,
};

export default MenuInformation;
